"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePickerInputField = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var format_1 = tslib_1.__importDefault(require("date-fns/format"));
var parse_1 = tslib_1.__importDefault(require("date-fns/parse"));
var isValid_1 = tslib_1.__importDefault(require("date-fns/isValid"));
var DayPickerInput_1 = tslib_1.__importDefault(require("react-day-picker/DayPickerInput"));
var DateRangePickerInputFieldBody_1 = require("./DateRangePickerInputFieldBody");
var getInputClassNames = function (className, classNameCalendar) { return ({
    container: classnames_1.default("gd-date-range-picker-input", className),
    overlay: classnames_1.default("gd-date-range-picker-picker", classNameCalendar),
    overlayWrapper: undefined,
}); };
function formatDate(date, dateFormat) {
    return format_1.default(date, dateFormat);
}
function parseDate(str, dateFormat) {
    try {
        var parsedDate = parse_1.default(str, dateFormat, new Date());
        // parse only dates with 4-digit years. this mimics moment.js behavior - it parses only dates above 1900
        // this is to make sure that the picker input is not overwritten in the middle of writing the year with year "0002" when writing 2020.
        //
        // it's also necessary to parse only when the input string fully matches with the desired format
        // to make sure that the picker input is not overwritten in the middle of writing.
        // e.g, let's consider a case where dateFormat is "dd/MM/yyyy" and the DayPickerInput has already been filled with a valid string "13/09/2020",
        // then an user wants to change only the month "13/09/2020" -> "13/11/2020" by removing "09" and typing "11".
        // in such case the parsing should wait until the user completes typing "11" (otherwise if parsing is done right after the first "1" is typed,
        // the cursor automatically moves to the end of the string in the middle of writing, causing a bad experience for the user).
        if (isValid_1.default(parsedDate) &&
            parsedDate.getFullYear() >= 1000 &&
            str === formatDate(parsedDate, dateFormat)) {
            return parsedDate;
        }
        return;
    }
    catch (_a) {
        return;
    }
}
// eslint-disable-next-line react/display-name
exports.DateRangePickerInputField = react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement(DayPickerInput_1.default, tslib_1.__assign({}, props, { ref: ref, formatDate: formatDate, parseDate: parseDate, classNames: getInputClassNames(props.className, props.classNameCalendar), component: DateRangePickerInputFieldBody_1.DateRangePickerInputFieldBody, hideOnDayClick: false }))); });
//# sourceMappingURL=DateRangePickerInputField.js.map